import { createAction, props } from '@ngrx/store';

import { LiveGalleryTab, LiveGalleryTabView } from '@live/pages/live-gallery-page/interfaces';

export const selectTab = createAction('[Live Cameras Gallery] Select Tab', props<{ tab: LiveGalleryTab }>());
export const selectView = createAction('[Live Cameras Gallery] Select View', props<{ view: LiveGalleryTabView }>());
export const tabChanged = createAction('[Live Cameras Gallery] Cameras tab changed', props<{ tab: LiveGalleryTab }>());
